import { Spinner } from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ManagementErrorAlert, { EErrorAlert } from '../../../components/ManagementErrorAlert';

const LoginMobileConnectCallback: React.FC = () => {
    const [params] = useSearchParams();
    const [loading, setLoading] = useState<boolean>(true);
    const [alertError, setAlertError] = useState<EErrorAlert>();
    const [showAlertError, setShowAlertError] = useState<boolean>(false);
    const code = params.get('code');
    const error = params.has('error');
    const errorDescription = params.get('error_description');
    const state = params.get('state');
    const number = window.localStorage.getItem('mc-number');

    useEffect(() => {
        if (error) {
            const isInvalidMobileError = errorDescription?.includes('Unknown user');
            const typeError = isInvalidMobileError ? EErrorAlert.UNKNOW_USER : EErrorAlert.ERROR_GENERIC;
            setAlertError(typeError);
            setShowAlertError(true);
        } else {
            window.location.href = `${process.env.REACT_APP_LOGIN_APP_MC_SCHEMA}?code=${code}&redirectUri=${process.env.REACT_APP_LOGIN_MC_CALLBACK}&state=${state}&number=${number}`;
        }
    }, []);

    return (
        <>
            <div style={{ display: loading ? 'fixed' : 'none' }} className='c-spinner'>
                <Spinner size={24} />
                <span className='c-spinner-overlay'></span>
            </div>
            {showAlertError && <ManagementErrorAlert type={alertError} fromMC={true} />}
        </>
    );
};

export default LoginMobileConnectCallback;
